import * as ActionType from '../constants/ActionType'
import update from 'react/lib/update';

export const initialState = {
    'data': [],
    'loadingWidgets': []
};

function imageUpload(state = initialState, action) {
    switch (action.type) {
        case ActionType.REQUEST_IMAGE_UPLOAD:
        case ActionType.REQUEST_IMAGE_UPLOAD_ERROR:
            return {
                ...state,
            };
        case ActionType.RECEIVE_IMAGE_UPLOAD:

            let tmpData = state.data;

            const modifiedElement = action.payload;

            let modified = false;

            tmpData.map(function (dataEntry, index) {
                if (dataEntry.id.toString() === modifiedElement.id.toString()) {
                    tmpData[index] = modifiedElement;
                    modified = true;
                }
            });

            if (modified === false) {
                tmpData.push(modifiedElement);
            }

            return {
                ...state,
                data: tmpData,
            };
        case ActionType.DELETE_IMAGE_UPLOAD:
        case ActionType.DELETE_IMAGE_UPLOAD_ERROR:
            return {
                ...state
            };

        case ActionType.DELETE_IMAGE_UPLOAD_SUCCESS:
            let deletedIndex = false;
            let tmp = state.data;
            tmp.map(function (dataEntry, i) {
                if (dataEntry.id.toString() === action.imageUploadId.toString()) {
                    deletedIndex = i;
                }
            });
            if (deletedIndex !== false) {
                tmp.splice(deletedIndex, 1);
            }

            return {
                ...state,
                data: tmp
            };
        case ActionType.ADD_IMAGE_UPLOAD:

            return update(state, {
                data: {
                    $push: [action.payload]
                }
            });

        case ActionType.LOADING_WIDGET_SUCCESS:

            let tmpLoadingWidgets = state.loadingWidgets;
            tmpLoadingWidgets.push(action.widgetId);

            return {
                ...state,
                loadingWidgets: tmpLoadingWidgets,
            };

        default:
            return state
    }
}

export default imageUpload


// WEBPACK FOOTER //
// ./src/js/reducers/imageUpload.js